import { FC, useEffect, useState } from 'react';
import { InfoRow } from 'modules/ui/infoRow';
import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import {
  ContractDetailsSelector,
  ContractDetailsThunks,
} from 'modules/contractsOverviewPage/redux';
import { numberToLocaleString } from 'modules/utils';
import { Currency } from 'modules/ui/table/currencyContainer';
import { InfoRowWrapper } from './styled';
import {
  ContractsDetailsSection,
  getContractDataLabel,
  getContractDataTooltipLabel,
  skipInfoRow,
} from './helper';

export interface ContractsDetailsFormProps {
  number: string;
  section: ContractsDetailsSection;
}

export const ContractsDetailsForm: FC<ContractsDetailsFormProps> = ({
  number,
  section,
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      ContractDetailsThunks.fetchContractByNumber(decodeURIComponent(number)),
    );
  }, [dispatch, number]);

  const contractDetails = useAppSelector(
    ContractDetailsSelector.selectContractDetails,
  );

  const [contractData, setContractData] = useState<any>({});

  const displayCurrencyValue = (eurValue?: string) =>
    `${numberToLocaleString(eurValue)} ${Currency.EURO}`;

  useEffect(() => {
    switch (section) {
      case ContractsDetailsSection.DETAILS:
        setContractData({
          number: contractDetails?.number,
          signingDate: contractDetails?.signingDate,
          firstInstallmentDate: contractDetails?.firstInstallmentDate,
          activityStatus: contractDetails?.activityStatus,
          supplier: contractDetails?.supplier,
          subjectName: contractDetails?.subjectName,
          purchaseValueEur: displayCurrencyValue(
            contractDetails?.purchaseValueEur,
          ),
          leasingTypeCategory: contractDetails?.leasingTypeCategory,
          openDebtEur: displayCurrencyValue(contractDetails?.openDebtEur),
          bailAmountEur: displayCurrencyValue(contractDetails?.bailAmountEur),
          installmentAmountEur: displayCurrencyValue(
            contractDetails?.installmentAmountEur,
          ),
          remainingValueEur: displayCurrencyValue(
            contractDetails?.remainingValueEur,
          ),
          callNumber: contractDetails?.callNumber,
        });
        break;
      case ContractsDetailsSection.REPAYMENT_PLAN:
        setContractData({});
        break;
      case ContractsDetailsSection.FACILITY_INFORMATION:
        setContractData({
          objectType: contractDetails?.objectType,
          object: contractDetails?.object,
          subjectName: contractDetails?.subjectName,
          chassisNumber: contractDetails?.chassisNumber,
          manufactureYear: contractDetails?.manufactureYear,
          color: contractDetails?.color,
          registrationNumber: contractDetails?.registrationNumber,
          licenceNumber: contractDetails?.licenceNumber,
          firstRegistrationDate: contractDetails?.firstRegistrationDate,
          licenceDate: contractDetails?.licenceDate,
          licenceValidityDate: contractDetails?.licenceValidityDate,
        });
        break;
    }
  }, [section, contractDetails]);

  return (
    <div>
      {Object.keys(contractData).map(
        (key, index) =>
          !skipInfoRow(key, contractData) && (
            <InfoRowWrapper key={`${key}_wrap`}>
              <InfoRow
                key={key}
                label={getContractDataLabel(key, contractData)}
                value={contractData[key as keyof typeof contractData]}
                labelTooltip={getContractDataTooltipLabel(key, contractData)}
              />
            </InfoRowWrapper>
          ),
      )}
    </div>
  );
};
